// extracted by mini-css-extract-plugin
export default {"card":"CardSellers_card__9jb5Q","header":"CardSellers_header__kfbqx","photo":"CardSellers_photo__S--8e","name":"CardSellers_name__vEb03","details":"CardSellers_details__kvxr5"};